import { UlReportDevice } from './ul-report-device.model';

export class UlReportSetConfigNotification
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.FailedDevices) json.FailedDevices.map(d => new UlReportDevice(d));
        }
    }

    FailedDevices: UlReportDevice[];
    GatewayUId: string;
    TypeCode: number;
    WasSuccess = false;
}
